// export regex to allow only letters and spaces
export const engLettersAndSpaces = /^[a-zA-Z\s]*$/;
export const engAndArLettersAndSpaces =
    /^[A-Za-z\u0600-\u06FF\s]+(?<![0-9٠-٩])$/;
export const arabicEnglishAlphaNumericRegex =
    /^[a-zA-Z0-9[ İlإًٌُlآآdجحخهعغفقثصضطكمنتالبيسشظزوةىلارؤدذءأئ ]+$/;
export const englishAlphaNumericRegex = /^[a-zA-Z0-9]+$/;
// Allows Arabic or English characters, numbers, and spaces, but does NOT allow special characters
export const arabicEnglishAlphaNumericNoSpecialCharsRegex =
    /^[a-zA-Z0-9\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF\s]+$/;
export const hasArabicRegex =
    /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;
export const hasEnglishRegex = /[a-zA-Z]/;
// validate that a string contains at least two non-whitespace sequences (words) separated by whitespace.
export const atLeastTwoWordsRegex = /^\s*\S+\s+\S+.*$/;
export const atLeastOneLowerCaseLetterRegex = /^(?=.*[a-z]).*$/;
export const atLeastOneUpperCaseLetterRegex = /^(?=.*[A-Z]).*$/;
export const atLeastOneNumberRegex = /^(?=.*\d).*$/;
export const atLeastOneSpecialCharacterRegex =
    /^(?=.*[!@#$%^&*()_+[\]{};':"\\|,.<>/?]).*$/;

// Validates positive integers greater than 0, no decimals
export const positiveIntegerRegex = /^[1-9]\d*$/;
